// extracted by mini-css-extract-plugin
module.exports = {"tooltipHeader":"_2d06922a","tooltipBody":"_b2920725","tooltipButtonWrapper":"_41944990"};